// @flow
import styled from 'styled-components';
import SVGIcon from '~/core/icons/svg-icons';

const height = '2em';

export const Base = styled.div`
    background-color: ${p => (p.color ? p.color : p.theme.white)};
    cursor: pointer;
    font-size: 1.3em;
    height: ${height};
    position: relative;
`;

export const IconContainer = styled.div`
    align-items: center;
    background-color: ${p => (p.color ? p.color : p.theme.white)};
    display: flex;
    height: calc(${height} - 1px);
    justify-content: center;
    pointer-events: none;
    position: absolute;
    right: 0;
    width: 3rem;
`;

export const Icon = styled(SVGIcon)`
    flex: 0 0 3em;
    height: 1.1em;
    width: 1.1em;

    & > g {
        fill: ${p => p.theme.mainBrandColor};
    }
`;

export const Select = styled.select`
    appearance: none;
    background-color: transparent;
    border: none;
    border-bottom: 1px solid ${p => p.theme.mediumGrey};
    border-radius: 0;
    cursor: pointer;
    height: ${height};
    overflow: hidden;
    padding-left: 0.5em;
    position: absolute;
    top: 0;
    transition: border 0.2s ease-in;
    width: 100%;

    &:-moz-focusring {
        color: transparent;
        text-shadow: 0 0 0 #000;
    }

    &:hover,
    &:focus {
        border-bottom-color: ${p => p.theme.mainBrandColor};
        outline: none;
    }

    &:-ms-expand {
        display: none;
    }
`;



// WEBPACK FOOTER //
// ./src/components/widgets/dropdown/styles.js